<template>
    <section class="endpoint-section endpoint-scopes">
        <header>
            <h4 class="endpoint-section-title">Required OAuth scopes</h4>
        </header>
        <ul v-if="scopes.length" class="endpoint-scopes-list">
            <li v-for="(scope, index) in scopes" :key="index"
                :class="'endpoint-scope' + (Array.isArray(scope) ? ' endpoint-scope-split' : '')">
                <template v-if="Array.isArray(scope)">
                <span v-for="(eitherScope, index) in scope"
                      :key="index"
                      class="split-scope"
                >{{ eitherScope }}</span>
                </template>
                <span v-else>{{ scope }}</span>
            </li>
        </ul>
        <span v-else class="data-missing">This endpoint has no required scopes</span>
    </section>
</template>

<script>
  export default {
    name: 'EndpointScopes',

    props: {
      scopes: {
        type:     [ Object, Array ],
        required: true,
      },
    },
  };
</script>

<style scoped>
    .endpoint-section-title {
        margin: 0 0 1rem;
    }

    .endpoint-scopes-list {
        display:    flex;
        flex-wrap:  wrap;
        margin:     0;
        padding:    0;
        list-style: none;
    }

    .endpoint-scope {
        position:      relative;
        margin:        0;
        padding:       0.25rem 1rem;
        border-radius: 3px;
        background:    var(--color-gray-light);
    }

    .endpoint-scope + .endpoint-scope {
        margin-left: 0.5rem;
    }

    .data-missing {
        color: var(--color-gray-medium);
    }

    .endpoint-scope.endpoint-scope-split {
        padding:    1.25rem 0.5rem 0.5rem;
        background: var(--color-gray-lighter);
    }

    .endpoint-scope.endpoint-scope-split::before {
        content:        'ONE OF';
        position:       absolute;
        display:        block;
        font-size:      0.6rem;
        font-weight:    bold;
        letter-spacing: 1px;
        top:            0.25rem;
        color:          var(--color-gray-dark)
    }

    .endpoint-scope .split-scope {
        padding:       2px 6px;
        border-radius: 3px;
        background:    rgba(0, 0, 0, 0.05);
    }

    .endpoint-scope .split-scope + .split-scope {
        margin-left: 0.5rem;
    }
</style>
